import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from './config.service';


@Injectable()
export class HttpService {

  public options: RequestOptions;

  constructor(private http: Http, private configService: ConfigService) {
    this.options = new RequestOptions();
  }

  private getHeader() {
    let header = new Headers();
    header.append('Content-Type', 'application/json');
    header.append('Authorization', sessionStorage.getItem('sessionKey'));
    header.append('x-api-key', this.configService.get('x_api_key'));
    return header;
  }

  public get(url, header?) {
    return this.http.get(this.configService.get('base_url').toString() + url, { headers: this.getHeader() })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        return Observable.throw(err);
      });
  }

  public post(url, data, header?) {
    return this.http.post(this.configService.get('base_url').toString() + url, data, { headers: this.getHeader() })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        return Observable.throw(err);
      });;
  }
  
  _errorHandler(error: Response) {
    return Observable.throw(error || 'server error');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/http.service.ts